const config = {
  pagination: false,
  tableType: 'antd',
  columns: [
    {
      title: '渠道ID',
      dataIndex: 'id',
      width: 250,
    },
    {
      title: '渠道名称',
      dataIndex: 'label',
      ellipsis: true,
      width: 200,
    },
    {
      title: '是否有效',
      dataIndex: ['object', 'enabled'],
      width: 100,
      render: v => (v ? '有效' : '无效'),
      key: 'object.enabled',
    },
    {
      title: '排序',
      dataIndex: ['object', 'sortNumber'],
      width: 100,
      key: 'object.sortNumber',
    },
    {
      title: '描述',
      dataIndex: ['object', 'description'],
      ellipsis: true,
      width: 200,
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 100,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: "categoryNameKeyword",
      label: "分类名称",
      width:300
    },
    {
      name: "enabled",
      label: "状态",
      itemType: "select",
      data: [
        { label: "启用", key: true },
        { label: "停用", key: false },
      ],
      width:300
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      // auth: 'FlowChannelClassificationButton1',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [
    {
      label: "失效",
      disabled: 'btnDisabled',
      events: ["onClick:onUnEnabled"]
    },
    {
      label: "有效",
      disabled: 'btnDisabled',
      events: ["onClick:onEnabled"]
    },
  ],
}

export default config
